import axios from 'axios'
import config from './config'
import Vue from 'vue'

const endpoints = {
    reportList: '/report/list',
    report: '/report',
    //reportFns: '/report/fns',
    reportSettings: '/report/settings',
    reportDelete: '/report/delete',
    reportCheckTT: '/report/checkTradePoint',
    reportImageRotation: '/report/RotateImage',
    reportImport: '/report/import',
    qrCodeImport: '/report/qrcode',
    reportExport: '/report/export',
    reportDistinctValues: '/report/distinctValues',
    reportMultipleApprove: '/report/multipleApprove',
    newsList: '/news/list',
    news: '/news',
    newsDelete: '/news/delete',
    newsMakeVote: '/news/makeVote',
    commentsList: '/news/comments',
    commentSave: '/news/comment',
    commentDelete: '/news/commentDelete',
    // newsLikesList: '/news/likes',
    // newsViewsList: '/news/views',
    newsUsersList: '/news/users',
    newsExportUsers: '/news/exportUsers',
    project: '/project',
    projectList: '/project/list',
    projectInfo: '/project/info',
    projectInfoFilter: '/project/infoFilter',
    projectOrderSave: '/project/orderSave',
    motivationDelete: '/project/motivation/delete',
    motivationYoutubeLinkSave: '/project/motivation/linkSave',
    projectRegisterCode: '/project/registerCode',
    projectValidateCode: '/project/validateCode',
    projectVisualDesign: '/project/visualDesign',
    projectAppAccess: '/project/appAccess',
    user: '/user',
    usersList: '/user/list',
    usersCount: '/user/count',
    userDistinctValues: '/user/distinctValues',
    userSave: '/user/save',
    userDelete: '/user/delete',
    userDocumentRotation: '/user/RotateDocument',
    userSearch: '/user/search',
    userRecover: '/user/recover',
    userResetPassword: '/user/reset',
    userConfirmEmail: '/user/confirm',
    userChangePassword: '/user/changePassword',
    userSavePassword: '/user/savePassword',
    userRegister: '/user/register',
    userRefuse: '/user/refuse',
    userActivation: '/user/activation',
    userActivationInfo: '/user/activationInfo',
    userPaymentSettings: '/user/paymentSettings',
    userExport: '/user/export',
    userExportReport: '/user/exportReport',
    userCheckInn: '/user/checkInn',
    tradePointList: '/tradepoints/list',
    tradePointSave: '/tradepoints/',
    tradePointDelete: '/tradepoints/delete/',
    tradePointSearch: '/tradepoints/search',
    tradePointListForReport: '/tradepoints/listForReport',
    tradePointListForRegister: '/tradepoints/listForRegister',
    tradePointDistinctValues: '/tradepoints/distinctValues',
    tradePointExport: '/tradepoints/export',
    commonDistinctValues: '/common/distinctValues',
    sku: '/sku',
    skuGet: '/sku?api-version=1.1',
    skuList: '/sku/list?api-version=1.1',
    skuShortList: '/sku/shortList',
    skuDelete: '/sku/delete',
    skuSettings: '/sku/settingsList',
    skuSettingsSave: '/sku/settingsSave',
    skuGroupsSave: '/sku/saveGroups',
    skuSearch: '/sku/search',
    skuSearchForTable: '/sku/searchForTable',
    skuLinksSearch: '/sku/linksSearch',
    skuApplyLinks: '/sku/applyLinks',
    skuGroupList: '/sku/skuGroups',
    skuExport: '/sku/export',
    skuExportLink: '/sku/exportLink',
    profile: '/profile',
    profileSaveAgreements: '/profile/saveAgreements',
    profileRemoveExternal: '/profile/externalRemove',
    profileInfo: '/profile/info',
    profileDocs: '/profile/docs',
    profileCard: '/profile/card',
    summary: '/dashboard/summary',
    firstActionsComplete: '/dashboard/firstActionsComplete',
    roles: '/roles',
    rolesList: '/roles/list',
    rolesSaveList: '/roles/saveList',
    rolesDelete: '/roles/delete',
    rewards: '/rewards',
    rewardsList: '/rewards/list',
    rewardsAggregateList: '/rewards/aggregatedList',
    rewardsDelete: '/rewards/delete',
    rewardGroupList: '/rewards/rewardGroups',
    rewardsGroupsSave: '/rewards/saveGroups',
    rewardsExport: '/rewards/export',
    giftery: '/rewards/giftery',
    orders: '/orders',
    ordersList: '/orders/list',
    ordersProcess: '/orders/process',
    ordersCancel: '/orders/cancel',
    orderExtraData: '/orders/extraData',
    orderExtraDataRemove: '/orders/extraDataRemove',
    ordersComplete: '/orders/complete',
    ordersReceive: '/orders/receive',
    ordersRemove: '/orders/remove',
    orderDistinctValues: '/orders/distinctValues',
    ordersExport: '/orders/export',
    orderAddressList: '/orders/addresses',
    orderAddress: '/orders/address',
    orderConfirmAddress: '/orders/addressConfirm',
    makeGifteryOrder: '/orders/gifteryOrder',
    gifteryBalance: '/orders/gifteryBalance',
    makeOzonOrder: '/orders/ozonOrder',
    orderStatuses: '/orders/orderStatuses',
    orderHistory: '/orders/history',
    materials: '/materials',
    materialsTestResults: '/materials/testResults',
    materialsTestRating: '/materials/testRating',
    materialsList: '/materials/list',
    materialSave: '/materials/save',
    materialDelete: '/materials/delete',
    materialQuestionsSave: '/materials/saveQuestions',
    materialQuestionsImport: '/materials/importQuestions',
    materialStartTest: '/materials/startTest',
    materialMakeAnswer: '/materials/makeAnswer',
    materialResultsExport: '/materials/results/export',
    materialResultsExportDistinctValues: '/materials/results/DistinctValues',
    materialUpdateTestSession: '/materials/updateTestSession',
    materialFailTestSession: '/materials/failTestSession',
    materialStats: '/materials/stats',
    materialMakeVote: '/materials/makeVote',
    materialUsersList: '/materials/users',
    materialUpdateProgress: '/materials/progress',
    materialExportUsers: '/materials/exportUsers',
    materialCertificate: '/materials/certificate',
    materialCertificateData: '/materials/certificateData',
    materialCertificateDownload: '/materials/certificateDownload',
    materialCertificateExport: '/materials/certificateExport',
    materialCertificateDistinctValues: '/materials/certificate/DistinctValues',
    materialResultsExportUsers: '/materials/results/exportUsers',
    folderList: '/folder/list',
    folderDelete: '/folder/delete',
    folder: '/folder',
    folderArchive: '/folder/archive',
    folderRestore: '/folder/restore',
    analytics: '/stats',
    analyticsDetails: '/stats/details',
    analyticsExport: '/stats/export',
    analyticsExportByReports: '/stats/exportByReports',
    analyticsDistinctValues: '/common/statsValues',
    rating: '/rating',
    ratingDistinctValues: '/rating/distinctValues',
    ratingExport: '/rating/export',
    ratingSettings: '/rating/settings',
    bonusHistoryList: '/bonusHistory/list',
    bonusHistoryDistinctValues: '/bonusHistory/distinctValues',
    bonusHistoryExport: '/bonusHistory/export',
    domainFoldersList: '/domainFolder/list',
    domainFolderDelete: '/domainFolder/delete',
    domainFolder: '/domainFolder',
    domainFolderArchive: '/domainFolder/archive',
    domainFolderRestore: '/domainFolder/restore',
    checkDownloaded: '/common/checkDownloaded',
    newsletter: '/newsletter',
    bulkSendingTemplates: '/bulkSending/templates',
    bulkSendingTemplateSave: '/bulkSending/templateSave',
    bulkSendingTemplateDelete: '/bulkSending/templateDelete',
    bulkSendingTest: '/bulkSending/test',
    bulkSending: '/bulkSending/',
    bulkSendingSave: '/bulkSending',
    bulkSendingDelete: '/bulkSending/delete',
    bulkSendingList: '/bulkSending/list',
    bulkSendingReceiversList: '/bulkSending/receivers',
    bulkSendingStats: '/bulkSending/stats',
    bulkSendingLogsList: '/bulkSending/logs',
    bulkSendingExportDetails: '/bulkSending/exportDetails',
    smtpSettingsList: '/bulkSending/smtp',
    smsLimits: '/bulkSending/smslimits',
    changeUser: '/account/change-user',
    returnUser: '/account/return-to-user',
    checkUser: '/account/checkUser',
    confirmationCode: '/user/code',
    checkConfirmationCode: '/user/checkcode',
    saveSecondsProgress: '/common/secondsProgress',
    getBankNameByBik: '/common/bik',
    getFileExport: '/common/exported',
    commonBulkSending: '/common/bulkSending',
    commonOzonAccounts: '/common/ozonAccounts',
    commonCountries: '/common/countries',
    commonNotificationList: '/common/notification/list',
    commonImageRotation: '/common/image/rotate',
    tasksList: '/tasks/list?api-version=1.0',
    tasks: '/tasks',
    tasksGet: '/tasks?api-version=1.1',
    tasksAnswerGet: '/tasks/answer?api-version=1.1',
    tasksAnswer: '/tasks/answer',
    tasksAnswers: '/tasks/answers',
    tasksDistinctValues: '/tasks/distinctValues',
    tasksMemberFilter: '/tasks/memberFilter',
    tasksAnswerAccept: '/tasks/answerAccept',
    tasksDelete: '/tasks/delete',
    tasksExport: '/tasks/export',
    tasksGeneralExport: '/tasks/generalExport',
    tasksExportReport: '/tasks/exportReport',
    tasksExportAnalyticsCersanit: '/tasks/exportAnalyticsCersanit',
    tasksExportAnalyticsJeelex: '/tasks/exportAnalyticsJeelex',
    tasksAnswersDetail: '/tasks/answers/detail',
    tasksDetailExport: '/tasks/detail/export',
    tasksBonus: '/tasks/bonus',
    tasksResponsible: '/tasks/responsible',
    tasksResponsibleRefuse: '/tasks/responsible/refuse',
    taskCheckResponsible: '/tasks/checkResponsible',
    tasksExportSku: '/tasks/export/sku',
    tasksImportSku: '/tasks/import/sku',
    tasksCopy: '/tasks/copy',
    tasksUsersOnRoles: '/tasks/usersOnRoles',
};

export default class {

    constructor(apiServer = (config.apiUrl + '/api')){
        this.apiServer = apiServer;
    }

    callApi(endpoint, data, method = 'GET', responseType = null, timeout = null) {
        timeout = timeout || 60000;
        let url = `${this.apiServer}${endpoint}`;
        let queryConfig = {
            params: {},
            timeout: timeout
        };
        if(responseType){
            queryConfig.responseType = responseType;
        }
        let headers = {};
        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
        let projectId = localStorage.getItem('selectedProjectId');

        if(tokenInfo){
            headers = {
                Authorization: 'bearer ' + tokenInfo.access_token,
                ProjectId : projectId
            };
            queryConfig.headers = headers;
        }
        else{
            let searchParam = new URLSearchParams(window.location.search);
            if(searchParam && searchParam.get('token') && searchParam.get('projectId')){
                headers = {
                    Authorization: 'bearer ' + searchParam.get('token'),
                    ProjectId : searchParam.get('projectId')
                };
                queryConfig.headers = headers;
            }
        }

        if(data){
            Object.assign(queryConfig.params, data);
        }

        let succesAction = (res) => {
            if(res.data.code !== 0){
                return {
                    hasError: true,
                    status: res.data.code,
                    //message: res.data.message
                };
            }

            return {
                hasError: false,
                data: res.data.result ? (res.data.result.data || res.data.result) : null
            };
        };
        let catchAction = (error) => {
            if (error.response && error.response.status === 401) {
                return {
                    hasError: true,
                    status: 401,
                    message: 'Unauthorized access'
                }
            }

            if (error.data) {
                console.error(error.data);
            }
            let exceptionMessage = error.response && error.response.data && error.response.data.ExceptionMessage ? error.response.data.ExceptionMessage : 'Inernal Server Error';
            return {
                hasError: true,
                status: 500,
                message: exceptionMessage
            }
        };
        if(method === 'GET'){
            return axios.get(url, queryConfig)
                .then(succesAction)
                .catch(catchAction)
        }
        else if (method === 'POST'){
            return axios
                .post(url, data, {headers: headers, timeout: timeout})
                .then(succesAction)
                .catch(catchAction);
        }
    }


    reportLoad (id, projectId) {
        return this.callApi(endpoints.report, {id, projectId});
    }

    reportList (skip, take, projectId, stateId, dateTypeId, dateStart, dateEnd, filter){
        return this.callApi(endpoints.reportList, {
            skip,
            take,
            projectId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter: ''
        })
    }

    reportSettingsList(projectId){
        return this.callApi(endpoints.reportSettings, {projectId});
    }

    reportSave (report){
        return this.callApi(endpoints.report, report, 'POST');
    }

    // reportFnsSave (report){
    //     return this.callApi(endpoints.reportFns, report, 'POST');
    // }

    reportDelete(id){
        return this.callApi(endpoints.reportDelete + `/${id}`, {}, 'POST');
    }

    reportCheckTT(tradePointId){
        return this.callApi(endpoints.reportCheckTT, {tradePointId});
    }

    rotateReportImage(id, direction){
        return this.callApi(endpoints.reportImageRotation, {
            imageId: id,
            direction
        });
    }

    reportImport(projectId, data){
        return this.callApi(endpoints.reportImport + `?projectId=${projectId}`, data, 'POST');
    }

    qrCodeImport(data){
        return this.callApi(endpoints.qrCodeImport,
            data
        , 'POST');
    }

    reportExport(projectId, filter, stateId, dateTypeId, dateStart, dateEnd){
        return this.callApi(endpoints.reportExport, {
            projectId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter: ''
        }, 'GET', null, 300000);
    }

    reportDistinctValues(columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.reportDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter : '',
            skip,
            take
        }, 'POST')
    }

    reportMultipleApprove(reports) {
        return this.callApi(endpoints.reportMultipleApprove, reports, 'POST');
    }

    newsList (skip, take, projectId){
        return this.callApi(endpoints.newsList, {
            skip,
            take,
            projectId
        })
    }

    newsLoad (id){
        return this.callApi(endpoints.news, {
            id
        })
    }

    newsSave(news){
        return this.callApi(endpoints.news, news, 'POST');
    }

    newsDelete (id){
        return this.callApi(endpoints.newsDelete + `/${id}`, {}, 'POST');
    }

    newsMakeVote (id){
        return this.callApi(endpoints.newsMakeVote, {
            Id: id
        }, 'POST');
    }

    commentsList(skip, take, newsId){
        return this.callApi(endpoints.commentsList, {
            skip,
            take,
            newsId
        })
    }

    // newsLikesList(skip, take, newsId){
    //     return this.callApi(endpoints.newsLikesList, {
    //         skip,
    //         take,
    //         newsId
    //     })
    // }
    //
    // newsViewsList(skip, take, newsId){
    //     return this.callApi(endpoints.newsViewsList, {
    //         skip,
    //         take,
    //         newsId
    //     })
    // }

    newsUsersList(skip, take, newsId) {
        return this.callApi(endpoints.newsUsersList, {
            skip,
            take,
            newsId
        })
    }

    newsExportUsers(id) {
        return this.callApi(endpoints.newsExportUsers, { id }, 'GET', null, 300000)
    }

    commentSave(data){
        return this.callApi(endpoints.commentSave, data, 'POST');
    }

    commentDelete (id){
        return this.callApi(endpoints.commentDelete + `/${id}`, {}, 'POST');
    }

    projectList(skip, take, active){
        return this.callApi(endpoints.projectList, {
            Skip: skip,
            Take: take,
            accessId: 0,
            Active: active
        })
    }

    projectInfo (){
        return this.callApi(endpoints.projectInfo)
    }

    projectInfoSave (project){
        return this.callApi(endpoints.projectInfo, project, 'POST')
    }

    projectInfoFilter() {
        return this.callApi(endpoints.projectInfoFilter)
    }

    projectOrderSave(projects){
        return this.callApi(endpoints.projectOrderSave, projects, 'POST')
    }

    projectLoad (id) {
        return this.callApi(endpoints.project, {id});
    }

    projectSave (project){
        return this.callApi(endpoints.project, project, 'POST');
    }

    projectDelete(projectId){
        return this.callApi(endpoints.project + '/delete/' + projectId, null, 'POST');
    }

    projectRegisterCode() {
        return this.callApi(endpoints.projectRegisterCode);
    }

    projectValidateCode(code) {
        return this.callApi(endpoints.projectValidateCode, {code});
    }

    projectVisualDesign(projectId) {
        return this.callApi(endpoints.projectVisualDesign, { projectId });
    }

    projectAppAccess(skip, take, accessId) {
        return this.callApi(endpoints.projectAppAccess, { skip, take, accessId})
    }

    projectAppAccessSave(project) {
        return this.callApi(endpoints.projectAppAccess, project, 'POST');
    }

    userLoad (userName, projectId) {
        return this.callApi(endpoints.user, {userName, projectId});
    }

    usersList (skip, take, projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd){
        return this.callApi(endpoints.usersList, {
            skip,
            take,
            projectId,
            filter: filter ? filter: '',
            roleId,
            dateSortEmpty,
            dateSortType,
            dateStart,
            dateEnd
        })
    }

    usersCount (projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd){
        return this.callApi(endpoints.usersCount, {
            projectId,
            filter: filter ? filter: '',
            roleId,
            dateSortEmpty,
            dateSortType,
            dateStart,
            dateEnd
        })
    }

    userDistinctValues (columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.userDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST')
    }

    userSave (user){
        return this.callApi(endpoints.userSave, user, 'POST');
    }

    userDelete (userName){
        return this.callApi(endpoints.userDelete, {userName}, 'POST');
    }

    rotateUserDocument(id, direction){
        return this.callApi(endpoints.userDocumentRotation, {
            imageId: id,
            direction
        });
    }

    userSearch(skip, take, projectId, roleId, searchText){
        return this.callApi(endpoints.userSearch, {
            skip,
            take,
            projectId,
            roleId,
            searchText: searchText ? searchText : ''
        })
    }

    userRecover(email){
        return this.callApi(endpoints.userRecover + `/${email}`, {}, 'POST');
    }

    userResetPassword(hash){
        return this.callApi(endpoints.userResetPassword + `/${hash}`, {});
    }

    userChangePassword(oldPassword, newPassword){
        return this.callApi(endpoints.userChangePassword, {
            oldPassword,
            newPassword
        }, 'POST');
    }

    userSavePassword(userName, password){
        return this.callApi(endpoints.userSavePassword, {
            userName,
            password
        }, 'POST');
    }

    userRegister(user){
        return this.callApi(endpoints.userRegister, user, 'POST');
    }

    userRefuse(user){
        return this.callApi(endpoints.userRefuse, user, 'POST');
    }

    userConfirmEmail(hash){
        return this.callApi(endpoints.userConfirmEmail + `/${hash}`, {});
    }

    userActivationInfo(hash){
        return this.callApi(endpoints.userActivationInfo + `/${hash}`, {});
    }

    userActivation(activationCode, password){
        return this.callApi(endpoints.userActivation, {
            activationCode,
            password
        }, 'POST');
    }

    savePaymentSettings(obj){
        return this.callApi(endpoints.userPaymentSettings, obj, 'POST');
    }
    
    userExport(projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd, notIncluded) {
        return this.callApi(endpoints.userExport, { projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd, notIncluded}, 'GET', null, 300000);
    }

    userExportReport(projectId, filter) {
        return this.callApi(endpoints.userExportReport, { projectId, filter }, 'GET', null, 300000);
    }

    userCheckInn(obj) {
        return this.callApi(endpoints.userCheckInn, obj, 'POST');
    }

    tradePointList (skip, take, projectId, filter) {
        return this.callApi(endpoints.tradePointList, {
            skip,
            take,
            projectId,
            filter: filter ? filter: ''
        })

    }

    tradePointSave (user){
        return this.callApi(endpoints.tradePointSave, user, 'POST');
    }

    tradePointDelete (id){
        return this.callApi(endpoints.tradePointDelete + `/${id}`, {}, 'POST');
    }

    tradePointSearch(skip, take, projectId, searchText){
        return this.callApi(endpoints.tradePointSearch, {
            skip,
            take,
            projectId,
            searchText
        })
    }

    tradePointListForReport(skip, take, projectId, searchText, allowed){
        return this.callApi(endpoints.tradePointListForReport, {
            skip,
            take,
            projectId: projectId || '',
            searchText,
            allowed
        })
    }

    tradePointListForRegister(skip, take, searchText){
        return this.callApi(endpoints.tradePointListForRegister, {
            skip,
            take,
            searchText
        })
    }

    tradePointDistinctValues (columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.tradePointDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST')
    }
    
    tradePointExport(projectId, filter) {
        return this.callApi(endpoints.tradePointExport, { projectId, filter: filter ? filter : '' }, 'GET', null, 300000);
    }

    skuList (skip, take, projectId, search, active, folderId){
        return this.callApi(endpoints.skuList, {
            skip,
            take,
            projectId,
            search: search == null ? '' : search,
            active,
            folderId
        })
    }

    skuShortList(skip, take, projectId) {
        return this.callApi(endpoints.skuShortList, {skip,take,projectId})
    }

    skuGroupList(projectId){
        return this.callApi(endpoints.skuGroupList, {
            projectId: projectId || ''
        })
    }

    skuApplyLinks(id, selectedIds, links){
        return this.callApi(endpoints.skuApplyLinks, {
            id: id,
            ids: selectedIds,
            links: links
        }, 'POST');
    }

    skuLoad (id, projectId, forEdit){
        return this.callApi(endpoints.skuGet, {
            id,
            projectId: projectId ? projectId : '',
            forEdit
        })
    }

    skuSave(sku){
        return this.callApi(endpoints.sku, sku, 'POST');
    }

    skuDelete (id){
        return this.callApi(endpoints.skuDelete + `/${id}`, {}, 'POST');
    }

    skuSearch(skip, take, tradePointId, searchText, fieldName){
        return this.callApi(endpoints.skuSearch, {
            skip,
            take,
            tradePointId,
            searchText: searchText ? searchText: '',
            fieldName
        })
    }

    skuSearchForTable(skip, take, tradePointId, searchText, fieldName, fieldId, skuView) {
        return this.callApi(endpoints.skuSearchForTable, {
            skip,
            take,
            tradePointId,
            searchText: searchText ? searchText : '',
            fieldName, fieldId, skuView
        })
    }

    skuLinksSearch(skip, take, projectId, searchText, linksExcepted){
        return this.callApi(endpoints.skuLinksSearch, {
            skip,
            take,
            projectId,
            searchText: searchText ? searchText: '',
            linksExcepted
        })
    }

    skuExport(projectId, search, active) {
        return this.callApi(endpoints.skuExport, { projectId: projectId || '', search, active}, 'GET', null, 300000)
    }

    skuExportLink(projectId, search, active) {
        return this.callApi(endpoints.skuExportLink, { projectId: projectId || '', search, active }, 'GET', null, 300000)
    }

    commonDistinctValues (tableName, columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.commonDistinctValues, {
            tableName,
            columnName,
            projectId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST')
    }

    domainFoldersList(projectId, domainTypeId, folderId){
        return this.callApi(endpoints.domainFoldersList, {
            projectId: projectId || '',
            domainTypeId,
            folderId: folderId || ''
        })
    }

    profileLoad(){
        return this.callApi(endpoints.profile);
    }

    profileSaveInfo (profile){
        return this.callApi(endpoints.profileInfo, profile, 'POST');
    }

    profileSaveDocs (profile){
        return this.callApi(endpoints.profileDocs, profile, 'POST');
    }

    profileSaveCard (profile){
        return this.callApi(endpoints.profileCard, profile, 'POST');
    }

    profileSaveAgreements (termsConfirmed, notificationsEnabled, personalDataEditingAccept){
        return this.callApi(endpoints.profileSaveAgreements, {
            termsConfirmed,
            notificationsEnabled,
            personalDataEditingAccept
        }, 'POST');
    }

    removeExternalLogin(loginProvider){
        return this.callApi(endpoints.profileRemoveExternal, {loginProvider}, 'GET');
    }

    summaryInfo(projectId){
        return this.callApi(endpoints.summary, {
            projectId: projectId ? projectId : ''
        });
    }

    firstActionsComplete(){
        return this.callApi(endpoints.firstActionsComplete, {});
    }

    skuSettings(projectId){
        return this.callApi(endpoints.skuSettings, {projectId})
    }

    skuSettingsSave (projectId, settingsDict){
        return this.callApi(endpoints.skuSettingsSave, {
            ProjectId: projectId,
            Fields: settingsDict
        }, 'POST');
    }

    skuGroupsSave(projectId, groups){
        return this.callApi(endpoints.skuGroupsSave + '/' + projectId, groups, 'POST');
    }

    rolesList (projectId){
        return this.callApi(endpoints.rolesList, {
            projectId
        })
    }

    rolesSave (role){
        return this.callApi(endpoints.roles, role, 'POST');
    }

    rolesSaveList(roles){
        return this.callApi(endpoints.rolesSaveList, roles, 'POST');
    }

    rolesDelete (id){
        return this.callApi(endpoints.rolesDelete + `/${id}`, {}, 'POST');
    }

    motivationSave(formData){

    }

    motivationDelete (projectId){
        return this.callApi(endpoints.motivationDelete + `/${projectId}`, {}, 'POST');
    }

    motivationYoutubeLinkSave(projectId, youtubeLink, videoName){
        return this.callApi(endpoints.motivationYoutubeLinkSave , {projectId, youtubeLink, videoName}, 'POST');
    }

    rewardsList (skip, take, projectId, search, onlyActive){
        return this.callApi(endpoints.rewardsList, {
            skip,
            take,
            projectId: projectId ? projectId : '',
            search: search == null ? '' : search,
            onlyActive: onlyActive
        })
    }

    rewardsAggregateList(skip, take, projectId, search, onlyActive, folderId, rewardType, active){
        return this.callApi(endpoints.rewardsAggregateList, {
            skip,
            take,
            projectId: projectId ? projectId : '',
            search: search == null ? '' : search,
            onlyActive: onlyActive,
            folderId,
            rewardType,
            active
        })
    }
    rewardsLoad (id){
        return this.callApi(endpoints.rewards, {
            id
        })
    }

    rewardsSave(data){
        return this.callApi(endpoints.rewards, data, 'POST');
    }

    rewardsDelete (id){
        return this.callApi(endpoints.rewardsDelete + `/${id}`, {}, 'POST');
    }

    rewardGroupList(projectId){
        return this.callApi(endpoints.rewardGroupList, {
            projectId: projectId || ''
        })
    }

    rewardsGroupsSave(projectId, groups){
        return this.callApi(endpoints.rewardsGroupsSave + '/' + projectId, groups, 'POST');
    }

    rewardsExport(folderId, search, active, rewardType) {
        return this.callApi(endpoints.rewardsExport, {
            search: search == null ? '' : search,
            folderId,
            rewardType,
            active
        }, 'GET', null, 300000)
    }

    ordersList (skip, take, projectId, dateStart, dateEnd, orderDateTypeId, orderStatus, filter, rewardTypeId){
        return this.callApi(endpoints.ordersList, {
            skip,
            take,
            projectId: projectId ? projectId : '',
            dateStart: dateStart || '',
            dateEnd: dateEnd || '',
            orderStatus: orderStatus || '',
            orderDateTypeId,
            filter: filter || '',
            rewardTypeId: rewardTypeId
        }, 'GET')
    }

    orderDistinctValues (columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.orderDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST')
    }

    orderPlace (order){
        return this.callApi(endpoints.orders, order, 'POST');
    }

    orderExtraData (orderId, fileData, fileName){
        return this.callApi(endpoints.orderExtraData, {
            orderId,
            fileData,
            fileName
        }, 'POST');
    }

    orderExtraDataRemove(orderId){
        return this.callApi(endpoints.orderExtraDataRemove + '/' + orderId, {}, 'POST')
    }

    orderProcess (orderIds){
        return this.callApi(endpoints.ordersProcess, {
            orderIds
        }, 'POST');
    }

    orderCancel (orderId, comment){
        return this.callApi(endpoints.ordersCancel, {
            orderId,
            comment
        }, 'POST');
    }

    orderComplete (orderIds){
        return this.callApi(endpoints.ordersComplete, {
            orderIds
        }, 'POST');
    }

    // orderComplete (orderId, fileData, fileName){
    //     return this.callApi(endpoints.ordersComplete, {
    //         orderId,
    //         fileData,
    //         fileName
    //     }, 'POST');
    // }

    orderReceive(orderId){
        return this.callApi(endpoints.ordersReceive + '/' + orderId, {}, 'GET');
    }

    orderReceiveWithDate(orderId, date){
        return this.callApi(endpoints.ordersReceive, {orderId, date}, 'POST');
    }

    orderRemove(orderId){
        return this.callApi(endpoints.ordersRemove + '/' + orderId, {}, 'POST');
    }

    ordersExport(projectId, dateStart, dateEnd, filter, orderDateTypeId, orderStatus) {
        return this.callApi(endpoints.ordersExport, {
            projectId: projectId ? projectId : '',
            dateStart,
            dateEnd,
            filter: filter ? filter: '',
            orderDateTypeId,
            orderStatus
        }, 'POST', null, 300000)
    }

    orderAddressList(userId) {
        return this.callApi(endpoints.orderAddressList, {
            userId: userId ? userId : ''
        });
    }

    orderConfirmAddress(address){
        return this.callApi(endpoints.orderConfirmAddress, address, 'POST');
    }

    orderNewAddress(fio, phoneNumber, fullAddress){
        return this.callApi(endpoints.orderAddress, {
            fio,
            phoneNumber,
            fullAddress
        }, 'POST');
    }

    exportUsers(){
        return this.callApi('/user/export', {}, 'GET', 'arraybuffer');
    }

    materialsList (skip, take, projectId, folderId, active){
        return this.callApi(endpoints.materialsList, {
            skip,
            take,
            projectId,
            folderId,
            active
        })
    }

    materialLoad (id, forTest = false){
        return this.callApi(endpoints.materials, {
            id,
            forTest
        })
    }

    materialLoadTestResults(id){
        return this.callApi(endpoints.materialsTestResults, {
            id
        })
    }

    materialLoadTestRating(id){
        return this.callApi(endpoints.materialsTestRating, {
            id
        })
    }

    materialSave(data){
        return this.callApi(endpoints.materials, data, 'POST');
    }

    materialDelete (id){
        return this.callApi(endpoints.materialDelete + `/${id}`, {}, 'POST');
    }

    materialQuestionsSave(data){
        return this.callApi(endpoints.materialQuestionsSave, data, 'POST');
    }

    materialMakeAnswer(data){
        return this.callApi(endpoints.materialMakeAnswer, data, 'POST');
    }

    materialStartTest (id){
        return this.callApi(endpoints.materialStartTest + `/${id}`, {}, 'POST');
    }

    materialUpdateTestSession (id){
        return this.callApi(endpoints.materialUpdateTestSession + `/${id}`, {}, 'POST');
    }

    materialFailTestSession (id){
        return this.callApi(endpoints.materialFailTestSession + `/${id}`, {}, 'POST');
    }

    materialQuestionsImport(data){
        return this.callApi(endpoints.materialQuestionsImport, data, 'POST');
    }

    materialStats(projectId){
        return this.callApi(endpoints.materialStats, {projectId});
    }

    materialResultsExport(materialId, filter, dateStart, dateEnd){
        return this.callApi(endpoints.materialResultsExport, {
            materialId,
            dateStart,
            dateEnd,
            filter: filter ? filter: ''
        }, 'POST', null, 300000);
    }

    materialResultsExportDistinctValues (columnName, materialId, search, filter, skip, take) {
        return this.callApi(endpoints.materialResultsExportDistinctValues, {
            columnName,
            materialId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST',null, 300000)
    }

    materialResultsExportUsers(materialId) {
        return this.callApi(endpoints.materialResultsExportUsers, { materialId }, 'GET', null, 300000);
    }

    materialMakeVote (id){
        return this.callApi(endpoints.materialMakeVote, {
            Id: id
        }, 'POST');
    }

    materialUsersList(skip, take, id) {
        return this.callApi(endpoints.materialUsersList, {
            skip,
            take,
            id
        })
    }

    materialUpdateProgress (materialFileId, page, duration){
        return this.callApi(endpoints.materialUpdateProgress, {materialFileId, page, duration: duration||null}, 'POST');
    }

    materialCertificate(skip, take, projectId, folderId, filter) {
        return this.callApi(endpoints.materialCertificate, {
            folderId,
            tableName: '',
            columnName: '',
            projectId,
            search: '',
            filter,
            skip,
            take  //skip, take, projectId, folderId, filter
        }, 'GET')
    }

    materialExportUsers(id) {
        return this.callApi(endpoints.materialExportUsers, { id }, 'GET', null, 300000);
    }

    materialCertificateData(Id, FileData, FileName, Delete) {
        return this.callApi(endpoints.materialCertificateData, { Id, FileData, FileName, Delete }, 'POST');
    }

    materialCertificateDownload(sessionId, fixDownload) {
        return this.callApi(endpoints.materialCertificateDownload, { sessionId, fixDownload });
    }

    materialCertificateExport(projectId, folderId, filter) {
        return this.callApi(endpoints.materialCertificateExport, { projectId, folderId, filter }, 'GET', null, 300000)
    }

    materialCertificateDistinctValues(skip, take, columnName, projectId, search, filter, folderId) {
        return this.callApi(endpoints.materialCertificateDistinctValues, { skip, take, columnName, projectId, search, filter, folderId }, 'POST')
    }

    folderList (projectId){
        return this.callApi(endpoints.folderList, {
            projectId: projectId || ''
        })
    }

    folderLoad (id){
        return this.callApi(endpoints.folder, {
            id
        })
    }

    folderSave(data){
        return this.callApi(endpoints.folder, data, 'POST');
    }

    folderDelete (id){
        return this.callApi(endpoints.folderDelete + `/${id}`, {}, 'POST');
    }

    folderArchive(obj) {
        return this.callApi(endpoints.folderArchive, obj, 'POST');
    }

    folderRestore(obj) {
        return this.callApi(endpoints.folderRestore, obj, 'POST');
    }

    domainFolderLoad (id){
        return this.callApi(endpoints.domainFolder, {
            id
        })
    }

    domainFolderSave(obj){
        return this.callApi(endpoints.domainFolder, obj, 'POST');
    }

    domainFolderDelete (id){
        return this.callApi(endpoints.domainFolderDelete + `/${id}`, {}, 'POST');
    }

    domainFolderArchive(obj) {
        return this.callApi(endpoints.domainFolderArchive, obj, 'POST');
    }

    domainFolderRestore(obj) {
        return this.callApi(endpoints.domainFolderRestore, obj, 'POST');
    }

    analyticsGetData(projectId, dateStart, dateEnd, unit, filter, measureType, skuId, asTable=false) {
        return this.callApi(endpoints.analytics, {
            projectId: projectId ? projectId : '',
            dateStart: dateStart,
            dateEnd: dateEnd,
            unit,
            filter: filter ? filter: '',
            measureType,
            skuId,
            asTable
        }, 'GET')
    }

    analyticsGetDetails(projectId, dateStart, dateEnd, unit, filter, measureType, skuId, asTable, customField) {
        return this.callApi(endpoints.analyticsDetails, {
            projectId: projectId ? projectId : '',
            dateStart: dateStart,
            dateEnd: dateEnd,
            unit,
            filter: filter ? filter: '',
            measureType,
            skuId,
            customField,
            asTable
        }, 'GET')
    }

    analyticsExport(projectId, dateStart, dateEnd, unit, filter, measureType, skuId) {
        return this.callApi(endpoints.analyticsExport, {
            projectId: projectId ? projectId : '',
            dateStart: dateStart,
            dateEnd: dateEnd,
            unit,
            filter: filter ? filter: '',
            measureType,
            skuId
        }, 'POST', null, 180000)
    }

    analyticsExportByReports(projectId, dateStart, dateEnd, unit, filter, measureType, skuId) {
        return this.callApi(endpoints.analyticsExportByReports, {
            projectId: projectId ? projectId : '',
            dateStart,
            dateEnd,
            unit,
            filter: filter ? filter : '',
            measureType,
            skuId
        }, 'POST', null, 180000)
    }

    analyticsDistinctValues(projectId, columnName) {
        return this.callApi(endpoints.analyticsDistinctValues, {
            projectId: projectId ? projectId : '',
            columnName
        })
    }

    ratingGetTop(skip, take, projectId, filter, sortColumn, sortDirection, ratingRole) {
        return this.callApi(endpoints.rating, {
            skip,
            take,
            projectId: projectId ? projectId : '',
            filter: filter || '',
            sortColumn,
            sortDirection,
            ratingRole
        }, 'GET')
    }


    ratingDistinctValues(columnName, projectId, search, filter, skip, take) {
        return this.callApi(endpoints.ratingDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter: '',
            skip,
            take
        }, 'POST')
    }

    ratingExport(projectId, filter, sortColumn, sortDirection, ratingRole){
        return this.callApi(endpoints.ratingExport, {
            projectId,
            filter: filter ? filter: '',
            sortColumn,
            sortDirection,
            ratingRole
        }, 'POST',null, 300000);
    }

    ratingSettings() {
        return this.callApi(endpoints.ratingSettings, {}, 'GET');
    }

    bonusHistoryList(skip, take, dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, projectId){
        return this.callApi(endpoints.bonusHistoryList, {
            skip,
            take,
            dateStart,
            dateEnd,
            bonusOperationTypeId,
            search,
            unit,
            monthAndYear,
            projectId
        })
    }

    bonusHistoryDistinctValues(columnName, dateStart, dateEnd, bonusOperationTypeId, search, monthAndYear, skip, take, projectId) {
        return this.callApi(endpoints.bonusHistoryDistinctValues, {
            columnName,
            dateStart,
            dateEnd,
            bonusOperationTypeId,
            search,
            monthAndYear,
            skip,
            take,
            projectId
        })
    }
    
    bonusHistoryExport(dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, projectId) {
        return this.callApi(endpoints.bonusHistoryExport, { dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, projectId}, 'GET', null, 300000)
    }

    checkDownloaded(guid){
        return this.callApi(endpoints.checkDownloaded, {guid})
    }

    bulkSendingTemplateSave(data) {
        return this.callApi(endpoints.bulkSendingTemplateSave, data, 'POST');
    }

    bulkSendingTemplates(projectId){
        return this.callApi(endpoints.bulkSendingTemplates, {
            projectId: projectId || ''
        })
    }

    bulkSendingTemplateDelete(id){
        return this.callApi(endpoints.bulkSendingTemplateDelete + `/${id}`, {}, 'POST');
    }

    bulkSendingTest(text, subject, bulkSendingType, smtpServerId, projectId){
        return this.callApi(endpoints.bulkSendingTest, {text, subject, bulkSendingType, smtpServerId, projectId}, 'POST');
    }

    //bulkSending(templateId, notIncluded, filter, projectId, templateName, body, bulkSendingTypeId, smtpServerId, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd,allCurrentUsersSelected) {
    //    return this.callApi(endpoints.bulkSending, {
    //        templateId,
    //        notIncluded,
    //        filter,
    //        projectId,
    //        templateName,
    //        body,
    //        bulkSendingTypeId,
    //        smtpServerId,
    //        roleId,
    //        dateSortEmpty,
    //        dateSortType,
    //        dateStart,
    //        dateEnd,
    //        allCurrentUsersSelected
    //    }, 'POST');
    //}

    bulkSending(id) {
        return this.callApi(endpoints.bulkSending, {id}, 'GET');
    }

    bulkSendingDelete(id) {
        return this.callApi(endpoints.bulkSendingDelete + `/${id}`, {}, 'POST');
    }

    bulkSendingSave(model) {
        return this.callApi(endpoints.bulkSendingSave, model, 'POST');
    }

    bulkSendingList(skip, take, bulkSendingType, projectId, startDate, endDate){
        return this.callApi(endpoints.bulkSendingList, {
            skip,
            take,
            bulkSendingType: bulkSendingType || '',
            projectId: projectId || '',
            startDate,
            endDate
        }, 'GET');
    }

    bulkSendingLogs(skip, take, projectId){
        return this.callApi(endpoints.bulkSendingLogsList, {
            skip,
            take,
            projectId: projectId || ''
        }, 'GET');
    }

    bulkSendingReceiversList(skip, take, bulkSendingId){
        return this.callApi(endpoints.bulkSendingReceiversList, {
            skip,
            take,
            bulkSendingId
        }, 'GET');
    }

    bulkSendingStats(projectId, startDate, endDate){
        return this.callApi(endpoints.bulkSendingStats, {
            projectId: projectId || '',
            startDate,
            endDate
        }, 'GET');
    }

    bulkSendingExportDetails(bulkSendingId, bulkSendingType, projectId, startDate, endDate) {
        return this.callApi(endpoints.bulkSendingExportDetails, { bulkSendingId, bulkSendingType, projectId, startDate, endDate }, 'GET', null, 300000);
    }

    smtpSettings(){
        return this.callApi(endpoints.smtpSettingsList, {}, 'GET');
    }

    smsLimits(){
        return this.callApi(endpoints.smsLimits, {});
    }

    changeUser(userId){
        return this.callApi(endpoints.changeUser, {
            userId
        }, 'GET');
    }

    returnToUser(checkData){
        return this.callApi(endpoints.returnUser, {
            checkData
        }, 'GET');
    }

    checkUser(userId){
        return this.callApi(endpoints.checkUser, {
            userId
        }, 'GET');
    }

    gifteryProducts(){
        return this.callApi(endpoints.giftery);
    }

    requestConfirmationCode(newemail){
        return this.callApi(endpoints.confirmationCode, {newemail});
    }

    checkConfirmationCode(code){
        return this.callApi(endpoints.checkConfirmationCode,{code});
    }

    makeGifteryOrder(orderId){
        return this.callApi(endpoints.makeGifteryOrder, {orderId}, 'GET');
    }

    getGifteryBalance(projectId){
        return this.callApi(endpoints.gifteryBalance, {projectId});
    }

    makeOzonOrder(orderId) {
        return this.callApi(endpoints.makeOzonOrder, { orderId }, 'GET');
    }

    getOrderStatuses(orderIds){
        return this.callApi(endpoints.orderStatuses, {orderIds: orderIds && orderIds.length ? orderIds :[0]});
    }

    saveSecondsProgress(seconds){
        return this.callApi(endpoints.saveSecondsProgress, {seconds});
    }

    orderHistory(id){
        return this.callApi(endpoints.orderHistory, {id});
    }

    getBankNameByBik(bik){
        return this.callApi(endpoints.getBankNameByBik, {bik});
    }

    fileExported(exportFile) {
        return this.callApi(endpoints.getFileExport, { exportFile }, 'GET', null, 300000);
    }

    commonBulkSending(model) {
        return this.callApi(endpoints.commonBulkSending, model, 'POST');
    }

    commonOzonAccounts() {
        return this.callApi(endpoints.commonOzonAccounts);
    }

    commonCountries() {
        return this.callApi(endpoints.commonCountries);
    }

    commonNotificationList(skip, take) {
        return this.callApi(endpoints.commonNotificationList, {skip, take});
    }

    commonImageRotation(filePath, direction) {
        return this.callApi(endpoints.commonImageRotation, {
            filePath,
            direction
        });
    }

    tasksList(skip, take, projectId, completed) {
        return this.callApi(endpoints.tasksList, { skip, take, projectId, completed });
    }

    tasksLoad(id, forDetail = false) {
        return this.callApi(endpoints.tasksGet, { id, forDetail })
    }

    tasksSave(task) {
        return this.callApi(endpoints.tasks, task, 'POST');
    }

    tasksAnswerSave(tasks) {
        return this.callApi(endpoints.tasksAnswer, tasks, 'POST');
    }

    tasksAnswerLoad(tasksId, answerId, tradePointId = null) {
        return this.callApi(endpoints.tasksAnswerGet, { tasksId, answerId, tradePointId}, 'GET');
    }

    tasksAnswers(skip, take, projectId, taskId, stateId, dateTypeId, dateStart, dateEnd, filter, author=null) {
        return this.callApi(endpoints.tasksAnswers, {
            skip,
            take,
            projectId,
            taskId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter : '',
            author
        }, 'GET');
    }

    tasksDistinctValues(columnName, projectId, parentId, search, filter, skip, take) {
        return this.callApi(endpoints.tasksDistinctValues, {
            columnName,
            projectId,
            search,
            filter: filter ? filter : '',
            skip,
            take,
            parentId
        }, 'POST')
    }

    tasksMemberFilter(field, projectId, skip, take, filterVariant, taskId) {
        return this.callApi(endpoints.tasksMemberFilter, {field, projectId, skip, take, filterVariant, taskId }, 'GET')
    }

    tasksAnswerAccept(taskId, answerId, status, comment) {
        return this.callApi(endpoints.tasksAnswerAccept, { taskId, answerId, status, comment}, 'POST');
    }

    tasksDelete(id) {
        return this.callApi(endpoints.tasksDelete + `/${id}`, {}, 'POST');
    }

    tasksExport(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
        return this.callApi(endpoints.tasksExport, {
            projectId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter : ''
        },'GET', null, 300000);
    }

    tasksGeneralExport(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
        return this.callApi(endpoints.tasksGeneralExport, {
            projectId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter : ''
        }, 'GET', null, 300000);
    }

    tasksExportReport() {
        return this.callApi(endpoints.tasksExportReport, {}, 'GET', null, 300000);
    }

    tasksExportAnalyticsJeelex(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
        return this.callApi(endpoints.tasksExportAnalyticsJeelex, {
            projectId,
            stateId,
            dateTypeId,
            dateStart,
            dateEnd,
            filter: filter ? filter : ''
        }, 'GET', null, 300000);
    }

    tasksExportAnalyticsCersanit() {
        return this.callApi(endpoints.tasksExportAnalyticsCersanit, {}, 'GET', null, 300000);
    }

    tasksAnswersDetail(taskId, answerId) {
        return this.callApi(endpoints.tasksAnswersDetail, { taskId, answerId }, 'GET')
    }

    tasksDetailExport(taskId, stateId, dateTypeId, dateStart, dateEnd, filter) {
        return this.callApi(endpoints.tasksDetailExport, {taskId, stateId, dateTypeId, dateStart, dateEnd, filter: filter ? filter : ''}, 'GET', null, 300000)
    }

    tasksBonus(taskid) {
        return this.callApi(endpoints.tasksBonus, { taskid }, 'GET')
    }

    tasksResponsible(taskId, mode, tradePointId) {
        return this.callApi(endpoints.tasksResponsible, { taskId, mode, tradePointId}, 'POST');
    }

    tasksResponsibleRefuse(taskId, tradePointId) {
        return this.callApi(endpoints.tasksResponsibleRefuse, { taskId, tradePointId}, 'POST');
    }

    taskCheckResponsible(taskId, tradePointId) {
        return this.callApi(endpoints.taskCheckResponsible, { taskId, tradePointId }, 'GET');
    }

    tasksExportSku(skuList) {
        return this.callApi(endpoints.tasksExportSku, {skuList}, 'POST', null, 300000);
    }

    tasksImportSku(data) {
        return this.callApi(endpoints.tasksImportSku, data, 'POST');
    }

    tasksCopy(taskCopy) {
        return this.callApi(endpoints.tasksCopy, taskCopy, 'POST');
    }

    tasksUsersOnRoles(skip, take, taskId, searchText, roleValues, gradeValues) {
        return this.callApi(endpoints.tasksUsersOnRoles, {
            skip,
            take,
            taskId,
            searchText: searchText ? searchText : '',
            roleValues,
            gradeValues
        });
    }
}; 


// WEBPACK FOOTER //
// ./Content/src/backendApi.js